import React from 'react';
import { node, object, string } from 'prop-types';

import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { createSlug } from '../../util/urlHelpers';
import { formatMoney } from '../../util/currency';

import {
  AspectRatioWrapper,
  AvatarMedium,
  AvatarSmall,
  H4,
  H6,
  NamedLink,
  ResponsiveImage,
} from '../../components';

import css from './CheckoutPage.module.css';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { SecondaryTextButton } from '../../components/mui/Button';
import { ArrowBack } from '@mui/icons-material';
import { ListingOverview } from '../../components/ListingOverview/ListingOverview';

const DetailsSideCard = props => {
  const {
    listing,
    listingTitle,
    author,
    firstImage,
    layoutListingImageConfig,
    speculateTransactionErrorMessage,
    showPrice,
    processName,
    breakdown,
    intl,
  } = props;

  const location = useLocation();

  const { price, publicData } = listing?.attributes || {};
  const unitType = publicData.unitType || 'unknown';
  const authorName = author.attributes.profile.displayName;

  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'listing-card' } =
    layoutListingImageConfig || {};
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith(variantPrefix))
    : [];

  return (
    <div className={css.detailsSideColumn}>
      <div className={css.detailsContainerDesktop}>
        <AspectRatioWrapper
          width={aspectWidth}
          height={aspectHeight}
          className={css.detailsAspectWrapper}
        >
          <ResponsiveImage
            rootClassName={css.rootForImage}
            alt={listingTitle}
            image={firstImage}
            variants={variants}
          />
        </AspectRatioWrapper>
        <div className={css.listingDetailsWrapper}>
          <ListingOverview author={author} listing={listing} location={location} />
          {speculateTransactionErrorMessage}
        </div>

        {breakdown}
      </div>
      <div className={css.detailsBackLink}>
        <NamedLink
          name="ListingPage"
          params={{
            id: listing?.id?.uuid,
            slug: createSlug(listingTitle),
          }}
          to={{
            search: location.search,
          }}
        >
          <SecondaryTextButton startIcon={<ArrowBack />} onClick={() => {}}>
            <FormattedMessage id="CheckoutPage.back" />
          </SecondaryTextButton>
        </NamedLink>
      </div>
    </div>
  );
};

DetailsSideCard.defaultProps = {
  speculateTransactionErrorMessage: null,
  breakdown: null,
};

DetailsSideCard.propTypes = {
  listing: propTypes.listing.isRequired,
  listingTitle: string.isRequired,
  author: propTypes.user.isRequired,
  firstImage: propTypes.image.isRequired,
  layoutListingImageConfig: object.isRequired,
  speculateTransactionErrorMessage: node,
  processName: string.isRequired,
  breakdown: node,
};

export default DetailsSideCard;
